import FilterTag from "components/FilterTag";
import { CustomerAccount } from "models/accountSummary";
import { ApplicationUser } from "models/applicationUsers";
import { ClearTableFilterRequest } from "models/common";
import { PackageAmount, PackageStatus, PackageType } from "models/packages";
import { customerAccountDisplay } from "util/helpers";

export interface StaffPackagesFilterDetail {
    status?: PackageStatus | undefined;
    customer?: ApplicationUser | undefined;
    type?: PackageType | undefined;
    amount?: PackageAmount | undefined;
    friendlyId?: string | undefined;
    account?: CustomerAccount | undefined;
    trackingNumberSuffix?: string;
}

const StaffPackagesFilter = (props: { detail: StaffPackagesFilterDetail }) => {
    const { status, account, type, amount, friendlyId, trackingNumberSuffix } = props.detail;

    return (
        <div id="staff-card-active-filters">
            {status && (
                <FilterTag
                    filter={ClearTableFilterRequest.Status}
                    text={`Status: ${PackageStatus[status]}`}
                />
            )}
            {friendlyId && (
                <FilterTag
                    filter={ClearTableFilterRequest.FriendlyId}
                    text={`Package ID: ${friendlyId}`}
                />
            )}
            {account && (
                <FilterTag
                    filter={ClearTableFilterRequest.Customer}
                    text={`Customer: ${customerAccountDisplay(account)}`}
                />
            )}
            {type && (
                <FilterTag
                    filter={ClearTableFilterRequest.Type}
                    text={`Type: ${type.internalName}`}
                />
            )}
            {amount && (
                <FilterTag
                    filter={ClearTableFilterRequest.Amount}
                    text={`Amount: ${PackageAmount[amount]}`}
                />
            )}
            {trackingNumberSuffix && (
                <FilterTag
                    filter={ClearTableFilterRequest.TrackingNumber}
                    text={`Tracking # Last 4: ${trackingNumberSuffix}`}
                />
            )}
        </div>
    );
};

export default StaffPackagesFilter;
